import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core';
import type { Grant } from '../../api/RebacExplorerClient';

interface RevokeModalProps {
  grant: Grant | null;
  objectLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function RevokeModal({ grant, objectLabel, onConfirm, onCancel }: RevokeModalProps) {
  if (!grant) return null;

  const isOwner = grant.relation === 'owner';

  return (
    <Dialog open onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{isOwner ? 'Revogação bloqueada' : 'Revogar acesso'}</DialogTitle>
      <DialogContent>
        {isOwner ? (
          <Typography variant="body2">
            A relação <strong>owner</strong> não pode ser revogada aqui — use Transferir Ownership (S4.3).
          </Typography>
        ) : (
          <Typography variant="body2">
            Revogar acesso <strong>{grant.relation}</strong> de{' '}
            <strong>{grant.user}</strong> em <strong>{objectLabel}</strong>?{' '}
            Esta ação é imediata e o usuário perderá o acesso.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="default" variant="outlined" size="small">
          Cancelar
        </Button>
        {!isOwner && (
          <Button onClick={onConfirm} color="secondary" variant="contained" size="small">
            Confirmar revogação
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
